export default __webpack_public_path__ + "static/media/ethopie.ed9871da.png";